import React from "react";
import OneInchExchange from "../assests/apps/1inch-exchange.jpg";
import TwoKey from "../assests/apps/2key.jpg";
import ThreeBox from "../assests/apps/3box.jpg";
import Mph88 from "../assests/apps/88mph.jpg";
import Aave from "../assests/apps/aave.jpg";
import AdexNetwork from "../assests/apps/adex-network.jpg";
import Affogato from "../assests/apps/affogato.jpg";
import Aka3 from "../assests/apps/aka3-email-alias.jpg";
import Alkemi from "../assests/apps/alkemi.jpg";
import Ankr from "../assests/apps/ankr.jpg";
import Arbitrum from "../assests/apps/arbitrum.jpg";
import Astrotools from "../assests/apps/astrotools-io.jpg";
import Autonomy from "../assests/apps/Autonomy.png";
import Axion from "../assests/apps/axion.jpg";
import BProtocol from "../assests/apps/b-protocol.jpg";
import Balancer from "../assests/apps/Balancer.png";
import Betoken from "../assests/apps/betoken.jpg";
import Binancedex from "../assests/apps/binancedex.jpg";
import Bitpif from "../assests/apps/bitpif.jpg";
import BulkSender from "../assests/apps/bulksender.jpg";
import CeloTerminal from "../assests/apps/celo-terminal.jpg";
import ChangeNow from "../assests/apps/change-now.jpg";
import CivTrade from "../assests/apps/civ-trade.jpg";
import Clovers from "../assests/apps/clovers.jpg";
import CoinStats from "../assests/apps/coin-stats.png";
import Compound from "../assests/apps/compound.jpg";
import CreamFinance from "../assests/apps/cream-finance.jpg";
import CryptoArchi from "../assests/apps/crypto-archi-finance.jpg";
import Curve from "../assests/apps/curve.jpg";
import Daohaus from "../assests/apps/daohaus.png";
import DaoLunch from "../assests/apps/daol-lunch.jpg";
import DaoStack from "../assests/apps/daostack.jpg";
import Dapprader from "../assests/apps/dapprader.jpg";
import DetaminNetwork from "../assests/apps/datamine-network.jpg";
import Ddex from "../assests/apps/ddex.jpg";
import DeBank from "../assests/apps/debank.jpg";
import Decentraland from "../assests/apps/decentraland.jpg";
import DefiPrime from "../assests/apps/defi-prime.jpg";
import DefiSaver from "../assests/apps/defi-saver.jpg";
import Definer from "../assests/apps/definer.jpg";
import DeltaTheta from "../assests/apps/delta-theta.jpg";
import DexAg from "../assests/apps/dex-ag.jpg";
import DexBlue from "../assests/apps/dex-blue.jpg";
import Dodo from "../assests/apps/dodo.jpg";
import DogsOfElon from "../assests/apps/dogs-of-elon.jpg";
import Domani from "../assests/apps/domani.png";
import DyDx from "../assests/apps/dydx.jpg";
import EnsDomain from "../assests/apps/ens-domain.jpg";
import Escaroo from "../assests/apps/escaroo.jpg";
import Etherscan from "../assests/apps/etherscan.jpg";
import Eyesfi from "../assests/apps/eyesfi.jpg";
import Fleek from "../assests/apps/fleek.jpg";
import Flexa from "../assests/apps/flexa.jpg";
import ForestKnight from "../assests/apps/forest-knight.jpg";
import Furucombo from "../assests/apps/furucombo.jpg";
import FuseStacking from "../assests/apps/fuse-stalking.jpg";
import GhostMarket from "../assests/apps/ghost-market.jpg";
import GnosisSafe from "../assests/apps/gnosis-safe.jpg";
import Graflr from "../assests/apps/graflr.png";
import HarvestFinance from "../assests/apps/harvest-finance.jpg";
import HelioWallet from "../assests/apps/heliowallet.jpg";
import HimegamiProtocol from "../assests/apps/himegami-protocol.jpg";
import HoneySwap from "../assests/apps/honeyswap.jpg";
import IdleFinance from "../assests/apps/idle-finance.jpg";
import InvoiceBuild from "../assests/apps/incoice-builder.jpg";
import IndexCoop from "../assests/apps/index-coop.jpg";
import InstaDapp from "../assests/apps/instadapp.jpg";
import KickBack from "../assests/apps/kickback.jpg";
import KnownOrigin from "../assests/apps/knoworigin.jpg";
import Krystal from "../assests/apps/krystal.jpg";
import KyberSwap from "../assests/apps/kyberswap.jpg";
import Lido from "../assests/apps/lido.jpg";
import LinkDrop from "../assests/apps/linkdrop.jpg";
import LivepeerExplorer from "../assests/apps/livepeer-explorer.jpg";
import LocalCryptos from "../assests/apps/local-cryptos.jpg";
import Loopring from "../assests/apps/loopring.jpg";
import MantraDao from "../assests/apps/mantra-dao.jpg";
import MaskNetwork from "../assests/apps/mask-network.png";
import MaskBook from "../assests/apps/maskbook.jpg";
import Matcha from "../assests/apps/matcha.jpg";
import MaticNetwork from "../assests/apps/matic-network.jpg";
import McDex from "../assests/apps/mcdex.jpg";
import Mesa from "../assests/apps/mesa.jpg";
import MetaSpace from "../assests/apps/Metaspace.jpg";
import MintBase from "../assests/apps/mintbase.jpg";
import MoonKat from "../assests/apps/moon-kat.jpg";
import MoonCatWorld from "../assests/apps/mooncat-world.jpg";
import Mooni from "../assests/apps/mooni.jpg";
import mstable from "../assests/apps/mstable.png";
import MulanFinance from "../assests/apps/mulan-finance.jpg";
import MyCrypto from "../assests/apps/mycrypto.jpg";
import MyEtherWallet from "../assests/apps/myetherwallet.jpg";
import Nash from "../assests/apps/nash.jpg";
import NftBankAi from "../assests/apps/nft-bank-ai.jpg";
import NftyConnect from "../assests/apps/nfty-connect.jpg";
import Oasis from "../assests/apps/oasis-app.jpg";
import Opensea from "../assests/apps/opensea.jpg";
import OptimisticLoogies from "../assests/apps/OptimisticLoogies.png";
import OrchidProtocol from "../assests/apps/orchid-protocol.jpg";
import PancakeSwap from "../assests/apps/pancake-swap.jpg";
import ParaSwap from "../assests/apps/paraswap.jpg";
import PitchApp from "../assests/apps/pitch-app.jpg";
import Plotx from "../assests/apps/plotx.jpg";
import PoolTogether from "../assests/apps/pooltogether.jpg";
import ProofofHumanity from "../assests/apps/proof-of-humanity.jpg";
import Quixotic from "../assests/apps/quixotic.png";
import Rarible from "../assests/apps/rarible.jpg";
import RavenProtocol from "../assests/apps/raven-protocol.jpg";
import RcnFinance from "../assests/apps/rcn-finance.jpg";
import Rubic from "../assests/apps/rubic.jpg";
import Sablier from "../assests/apps/sablier.jpg";
import ShellExchange from "../assests/apps/shell-exchange.jpg";
import Snapshot from "../assests/apps/snapshot.jpg";
import Space from "../assests/apps/space.jpg";
import SpiritSwap from "../assests/apps/spirit-swap.jpg";
import SpookySwap from "../assests/apps/spooky-swap.jpg";
import StablePay from "../assests/apps/stablepay.jpg";
import StarName from "../assests/apps/starname.jpg";
import StellarX from "../assests/apps/stellar-x.png";
import Streamr from "../assests/apps/streamr.jpg";
import SuperRare from "../assests/apps/super-rare.jpg";
import SushiSwap from "../assests/apps/sushiswap.jpg";
import SwapX from "../assests/apps/swapx.jpg";
import SwapZone from "../assests/apps/swapzone.jpg";
import Synthetis from "../assests/apps/synthetis.jpg";
import ThorChain from "../assests/apps/thorchain.jpg";
import TokamakNetwork from "../assests/apps/tokamak-network.jpg";
import TokenSets from "../assests/apps/tokensets.jpg";
import Totle from "../assests/apps/totle.jpg";
import TrinityFeeds from "../assests/apps/trinity-feeds.jpg";
import Twinci from "../assests/apps/twinci.jpg";
import TyrelYutaniHub from "../assests/apps/tyrel-yutani-hub.jpg";
import Uswap from "../assests/apps/u-swap.jpg";
import Unagii from "../assests/apps/unagii.jpg";
import UniSwap from "../assests/apps/uniswap.jpg";
import UnlockProtocol from "../assests/apps/unlock-protocol.png";
import UnstoppableDomain from "../assests/apps/unstoppable-domain.png";
import VesperFinance from "../assests/apps/vesper-finance.jpg";
import VisionCryptoWallet from "../assests/apps/vision-crypto-wallet.png";
import Yearn from "../assests/apps/yearn.jpg";
import Yfx from "../assests/apps/yfx.jpg";
import Yoshi from "../assests/apps/yooshi.png";
import Yup from "../assests/apps/yup.png";
import Zksync from "../assests/apps/zksync.jpg";
import Zlot from "../assests/apps/zlot.jpg";
import PerApps from "./PerApps";

const AllApps = () => {
  return (
    <div className="flex flex-col mx-8 mt-5 space-y-10 text-center align-middle">
      <div className="flex justify-center">
        <div className="grid  grid-cols-1 gap-8 mt-4 sm:grid-cols-2 md:grid-cols-4">
          <PerApps
            myLink="#"
            src={OneInchExchange}
            caption="1inch Exchange"
            walletsName="1inch Exchage"
            appName="1inch-exchange"
          />
          <PerApps
            myLink="#"
            src={TwoKey}
            caption="2Key"
            // walletsName="2Key"
            appName="2key"
          />
          <PerApps
            myLink="#"
            src={ThreeBox}
            caption="3Box"
            walletsName="3Box"
            appName="3box"
          />
          <PerApps
            myLink="#"
            src={Mph88}
            caption="88Mph"
            walletsName="88Mph"
            appName="88mph"
          />
          <PerApps myLink="#" src={Aave} caption="Aave" appName="aave" />
          <PerApps
            myLink="#"
            src={AdexNetwork}
            caption="Adex Network"
            appName="adex-network"
          />
          <PerApps
            myLink="#"
            src={Affogato}
            caption="Affogato"
            appName="affogato"
          />
          <PerApps
            myLink="#"
            src={Aka3}
            caption="Aka3 Email Alias"
            appName="aka3"
          />
          <PerApps myLink="#" src={Alkemi} caption="Alkemi" appName="alkemi" />
          <PerApps myLink="#" src={Ankr} caption="Ankr" appName="ankr" />
          <PerApps
            myLink="#"
            src={Arbitrum}
            caption="Arbitrum"
            appName="arbitrum"
          />
          <PerApps
            myLink="#"
            src={Astrotools}
            caption="Astrotools.io"
            appName="astrotools"
          />
          <PerApps
            myLink="#"
            src={Autonomy}
            caption="Autonomy"
            appName="autonomy"
          />
          <PerApps myLink="#" src={Axion} caption="Axion" appName="axion" />
          <PerApps
            myLink="#"
            src={BProtocol}
            caption="B.Protocol"
            appName="b-protocol"
          />
          <PerApps
            myLink="#"
            src={Balancer}
            caption="Balancer"
            appName="balancer"
          />
          <PerApps
            myLink="#"
            src={Betoken}
            caption="Betoken"
            appName="betoken"
          />
          <PerApps
            myLink="#"
            src={Binancedex}
            caption="Binancedex"
            appName="binancedex"
          />
          <PerApps myLink="#" src={Bitpif} caption="Bitpif" appName="bitpif" />
          <PerApps
            myLink="#"
            src={BulkSender}
            caption="BulkSender"
            appName="bulksender"
          />
          <PerApps
            myLink="#"
            src={CeloTerminal}
            caption="Celo Terminal"
            appName="celo-terminal"
          />
          <PerApps myLink="#" src={ChangeNow} caption="ChangeNow" appName="" />
          <PerApps
            myLink="#"
            src={CivTrade}
            caption="CivTrade"
            appName="civ-trade"
          />
          <PerApps
            myLink="#"
            src={Clovers}
            caption="Clovers"
            appName="clovers"
          />
          <PerApps
            myLink="#"
            src={CoinStats}
            caption="CoinStats"
            appName="coinstats"
          />
          <PerApps
            myLink="#"
            src={Compound}
            caption="Compound"
            appName="compound"
          />
          <PerApps
            myLink="#"
            src={CreamFinance}
            caption="Cream Finance"
            appName="cream-finance"
          />
          <PerApps
            myLink="#"
            src={CryptoArchi}
            caption="Crypto Archi Finance"
            appName=""
          />
          <PerApps myLink="#" src={Curve} caption="Curve" appName="curve" />
          <PerApps
            myLink="#"
            src={Daohaus}
            caption="DAOhaus"
            appName="daohaus"
          />
          <PerApps
            myLink="#"
            src={DaoLunch}
            caption="DAOLunch"
            appName="daolunch"
          />
          <PerApps
            myLink="#"
            src={DaoStack}
            caption="DAOstack"
            appName="daostack"
          />
          <PerApps
            myLink="#"
            src={Dapprader}
            caption="Dapprader"
            appName="dapprader"
          />
          <PerApps
            myLink="#"
            src={DetaminNetwork}
            caption="Detamin Network"
            appName="detamin-network"
          />
          <PerApps myLink="#" src={Ddex} caption="DDEX" appName="ddex" />
          <PerApps myLink="#" src={DeBank} caption="DeBank" appName="debank" />
          <PerApps
            myLink="#"
            src={Decentraland}
            caption="Decentraland"
            appName="decentaland"
          />
          <PerApps
            myLink="#"
            src={DefiPrime}
            caption="DeFi Prime"
            appName="defi-prime"
          />
          <PerApps
            myLink="#"
            src={DefiSaver}
            caption="DeFi Saver"
            appName="defi-saver"
          />
          <PerApps
            myLink="#"
            src={Definer}
            caption="Definer"
            appName="definer"
          />
          <PerApps
            myLink="#"
            src={DeltaTheta}
            caption="Delta.Theta"
            appName="deltatheta"
          />
          <PerApps myLink="#" src={DexAg} caption="Dex.Ag" appName="dexag" />
          <PerApps
            myLink="#"
            src={DexBlue}
            caption="Dex.Blue"
            appName="dexblue"
          />
          <PerApps myLink="#" src={Dodo} caption="DODO" appName="dodo" />
          <PerApps
            myLink="#"
            src={DogsOfElon}
            caption="Dogs of Elon"
            appName="dogsofelon"
          />
          <PerApps myLink="#" src={Domani} caption="Domani" appName="domani" />
          <PerApps myLink="#" src={DyDx} caption="dYdX" appName="dydx" />
          <PerApps
            myLink="#"
            src={EnsDomain}
            caption="ENS Domains"
            appName="ensdomains"
          />
          <PerApps
            myLink="#"
            src={Escaroo}
            caption="Escaroo"
            appName="escaroo"
          />
          <PerApps
            myLink="#"
            src={Etherscan}
            caption="Etherscan"
            appName="etherscan"
          />
          <PerApps myLink="#" src={Eyesfi} caption="Eyesfi" appName="eyesfi" />
          <PerApps myLink="#" src={Fleek} caption="Fleek" appName="fleek" />
          <PerApps myLink="#" src={Flexa} caption="Flexa" appName="flexa" />
          <PerApps
            myLink="#"
            src={ForestKnight}
            caption="Forest Knight"
            appName="forest-knight"
          />
          <PerApps
            myLink="#"
            src={Furucombo}
            caption="Furucombo"
            appName="furucombo"
          />
          <PerApps
            myLink="#"
            src={FuseStacking}
            caption="Fuse Stacking"
            appName="fusestacking"
          />
          <PerApps
            myLink="#"
            src={GhostMarket}
            caption="Ghost Market"
            appName="ghostmarket"
          />
          <PerApps
            myLink="#"
            src={GnosisSafe}
            caption="Gnosis Safe Multisig"
            appName="gnosis-safe"
          />
          <PerApps myLink="#" src={Graflr} caption="Graflr" appName="graflr" />
          <PerApps
            myLink="#"
            src={HarvestFinance}
            caption="Harvest Finance"
            appName="harvest-finance"
          />
          <PerApps
            myLink="#"
            src={HelioWallet}
            caption="Helio Wallet"
            appName="helio-wallet"
          />
          <PerApps
            myLink="#"
            src={HimegamiProtocol}
            caption="Himegami Protocol"
            appName="himegami-protocol"
          />
          <PerApps
            myLink="#"
            src={HoneySwap}
            caption="Honey Swap"
            appName="honeyswap"
          />
          <PerApps
            myLink="#"
            src={IdleFinance}
            caption="Idle Finance"
            appName="idlefinance"
          />
          <PerApps
            myLink="#"
            src={InvoiceBuild}
            caption="Invoice.Build"
            appName="invoicebuilder"
          />
          <PerApps
            myLink="#"
            src={IndexCoop}
            caption="Index Coop"
            appName="indexcoop"
          />
          <PerApps
            myLink="#"
            src={InstaDapp}
            caption="InstaDapp"
            appName="instadapp"
          />
          <PerApps
            myLink="#"
            src={KickBack}
            caption="Kickback"
            appName="kickback"
          />
          <PerApps
            myLink="#"
            src={KnownOrigin}
            caption="KnownOrigin"
            appName="knoworigin"
          />
          <PerApps
            myLink="#"
            src={Krystal}
            caption="Krystal"
            appName="krystal"
          />
          <PerApps
            myLink="#"
            src={KyberSwap}
            caption="Kyber Swap"
            appName="kyberswap"
          />
          <PerApps myLink="#" src={Lido} caption="Lido" appName="lido" />
          <PerApps
            myLink="#"
            src={LinkDrop}
            caption="Linkdrop"
            appName="linkdrop"
          />
          <PerApps
            myLink="#"
            src={LivepeerExplorer}
            caption="Livepeer Explorer"
            appName="livepeer"
          />
          <PerApps
            myLink="#"
            src={LocalCryptos}
            caption="Local Cryptos"
            appName="localcryptos"
          />
          <PerApps
            myLink="#"
            src={Loopring}
            caption="Loopring"
            appName="loopring"
          />
          <PerApps
            myLink="#"
            src={MantraDao}
            caption="MANTRA DAO"
            appName="mantradao"
          />
          <PerApps
            myLink="#"
            src={MaskNetwork}
            caption="Mask Network"
            appName="masknetwork"
          />
          <PerApps
            myLink="#"
            src={MaskBook}
            caption="Maskbook"
            appName="maskbook"
          />
          <PerApps myLink="#" src={Matcha} caption="Matcha" appName="matcha" />
          <PerApps
            myLink="#"
            src={MaticNetwork}
            caption="Matic Network"
            appName="maticnetwork"
          />
          <PerApps myLink="#" src={McDex} caption="MCDEX" appName="mcdex" />
          <PerApps myLink="#" src={Mesa} caption="Mesa" appName="mesa" />
          <PerApps
            myLink="#"
            src={MetaSpace}
            caption="Meta Space"
            appName="metaspace"
          />
          <PerApps
            myLink="#"
            src={MintBase}
            caption="Mintbase"
            appName="mintbase"
          />
          <PerApps
            myLink="#"
            src={MoonKat}
            caption="MoonKat"
            appName="moonkat"
          />
          <PerApps
            myLink="#"
            src={MoonCatWorld}
            caption="MoonCat World"
            appName="mooncat"
          />
          <PerApps myLink="#" src={Mooni} caption="Mooni" appName="mooni" />
          <PerApps
            myLink="#"
            src={mstable}
            caption="mStable"
            appName="mstable"
          />
          <PerApps
            myLink="#"
            src={MulanFinance}
            caption="Mulan Finance"
            appName="mulanfinance"
          />
          <PerApps
            myLink="#"
            src={MyCrypto}
            caption="MyCrypto"
            appName="mycrypto"
          />
          <PerApps
            myLink="#"
            src={MyEtherWallet}
            caption="MyEtherWallet"
            appName="myetherwallet"
          />
          <PerApps myLink="#" src={Nash} caption="Nash" appName="nash" />
          <PerApps
            myLink="#"
            src={NftBankAi}
            caption="NFTBank.ai"
            appName="nftbankai"
          />
          <PerApps
            myLink="#"
            src={NftyConnect}
            caption="NFTY Connect"
            appName="nftyconnect"
          />
          <PerApps myLink="#" src={Oasis} caption="Oasis" appName="oasis" />
          <PerApps
            myLink="#"
            src={Opensea}
            caption="Opensea"
            appName="opensea"
          />
          <PerApps
            myLink="#"
            src={OptimisticLoogies}
            caption="OptimisticLoogies"
            appName="optimisticloogies"
          />
          <PerApps
            myLink="#"
            src={OrchidProtocol}
            caption="Orchid Protocol"
            appName="orchidprotocol"
          />
          <PerApps
            myLink="#"
            src={PancakeSwap}
            caption="PancakeSwap"
            appName="pancakeswap"
          />
          <PerApps
            myLink="#"
            src={ParaSwap}
            caption="ParaSwap"
            appName="paraswap"
          />
          <PerApps
            myLink="#"
            src={PitchApp}
            caption="PitchApp"
            appName="pitchapp"
          />
          <PerApps myLink="#" src={Plotx} caption="PlotX" appName="PlotX" />
          <PerApps
            myLink="#"
            src={PoolTogether}
            caption="PoolTogether"
            appName="pooltogether"
          />
          <PerApps
            myLink="#"
            src={ProofofHumanity}
            caption="Proof of Humanity"
            appName="proofofhumanity"
          />
          <PerApps
            myLink="#"
            src={Quixotic}
            caption="Quixotic"
            appName="quixotic"
          />
          <PerApps
            myLink="#"
            src={Rarible}
            caption="Rarible"
            appName="rarible"
          />
          <PerApps
            myLink="#"
            src={RavenProtocol}
            caption="Raven Protocol"
            appName="ravenprotocol"
          />
          <PerApps
            myLink="#"
            src={RcnFinance}
            caption="RCN Finance"
            appName="rcn-finance"
          />
          <PerApps myLink="#" src={Rubic} caption="Rubic" appName="rubic" />
          <PerApps
            myLink="#"
            src={Sablier}
            caption="Sablier"
            appName="Sablier"
          />
          <PerApps
            myLink="#"
            src={ShellExchange}
            caption="Shell Exchange"
            appName="shell-exchange"
          />
          <PerApps
            myLink="#"
            src={Snapshot}
            caption="Snapshot"
            appName="snapshot"
          />
          <PerApps myLink="#" src={Space} caption="Space" appName="space" />
          <PerApps
            myLink="#"
            src={SpiritSwap}
            caption="SpiritSwap"
            appName="spiritswap"
          />
          <PerApps
            myLink="#"
            src={SpookySwap}
            caption="SpookySwap"
            appName="spookyswap"
          />
          <PerApps
            myLink="#"
            src={StablePay}
            caption="StablePay"
            appName="stablepay"
          />
          <PerApps
            myLink="#"
            src={StarName}
            caption="Star Name"
            appName="starname"
          />
          <PerApps
            myLink="#"
            src={StellarX}
            caption="StellarX"
            appName="stellarx"
          />
          <PerApps
            myLink="#"
            src={Streamr}
            caption="Streamr"
            appName="streamr"
          />
          <PerApps
            myLink="#"
            src={SuperRare}
            caption="SuperRare"
            appName="super-rare"
          />
          <PerApps
            myLink="#"
            src={SushiSwap}
            caption="SushiSwap"
            appName="sushiswap"
          />
          <PerApps myLink="#" src={SwapX} caption="SwapX" appName="SwapX" />
          <PerApps
            myLink="#"
            src={SwapZone}
            caption="SwapZone"
            appName="swapzone"
          />
          <PerApps
            myLink="#"
            src={Synthetis}
            caption="Synthetis"
            appName="synthetis"
          />
          <PerApps
            myLink="#"
            src={ThorChain}
            caption="ThorCain"
            appName="thorcain"
          />
          <PerApps
            myLink="#"
            src={TokamakNetwork}
            caption="Tokamak Network"
            appName="tokamaknetwork"
          />
          <PerApps
            myLink="#"
            src={TokenSets}
            caption="TokenSets"
            appName="tokensets"
          />
          <PerApps myLink="#" src={Totle} caption="Totle" appName="totle" />
          <PerApps
            myLink="#"
            src={TrinityFeeds}
            caption="Trinity Feeds"
            appName="trinity-feeds"
          />
          <PerApps myLink="#" src={Twinci} caption="Twinci" appName="twinci" />
          <PerApps
            myLink="#"
            src={TyrelYutaniHub}
            caption="Tyrel Yutani Hub"
            appName="tyrelyutanihub"
          />
          <PerApps myLink="#" src={Uswap} caption="U-Swap" appName="uswap" />
          <PerApps myLink="#" src={Unagii} caption="Unagii" appName="unagii" />
          <PerApps
            myLink="#"
            src={UniSwap}
            caption="UniSwap"
            appName="uniswap"
          />
          <PerApps
            myLink="#"
            src={UnlockProtocol}
            caption="Unlock Protocol"
            appName="unlock protocol"
          />
          <PerApps
            myLink="#"
            src={UnstoppableDomain}
            caption="Unstoppable Domain"
            appName="unstoppable-domain"
          />
          <PerApps
            myLink="#"
            src={VesperFinance}
            caption="Vesper Finance"
            appName="vesper-finance"
          />
          <PerApps
            myLink="#"
            src={VisionCryptoWallet}
            caption="Vision: Crypto Wallet"
            appName="visioncrypto"
          />
          <PerApps myLink="#" src={Yearn} caption="Yearn" appName="yearn" />
          <PerApps myLink="#" src={Yfx} caption="YFX" appName="yfx" />
          <PerApps myLink="#" src={Yoshi} caption="Yoshi" appName="yoshi" />
          <PerApps myLink="#" src={Yup} caption="YUP" appName="yup" />
          <PerApps myLink="#" src={Zksync} caption="zkSync" appName="zksync" />
          <PerApps myLink="#" src={Zlot} caption="zLOT" appName="zlot" />
        </div>
      </div>
    </div>
  );
};

export default AllApps;
